import { Stack, TableCell, styled, useTheme } from "@mui/material"
import { Chip } from "@pharmupp/p3-front-commons"
import { OperationStateEnum } from "../../AdherentMarketingOperations"
import {
  type MarketingOpTypesName,
  marketingOpTypesEnum,
} from "../../marketingOperationReferential"

interface TypeCellProps {
  type: MarketingOpTypesName
  state: string
  year: string
  hidden?: boolean
}

const TypeChip = styled(Chip)(({ theme: { typography } }) => ({
  fontSize: typography.pxToRem(9),
}))
TypeChip.defaultProps = { size: "small" }

export const TypeCell = ({ type, state, year, hidden = false }: TypeCellProps) => {
  const { label, color } = marketingOpTypesEnum[type]
  const isDisabled =
    [OperationStateEnum.OUTDATED, OperationStateEnum.EXPIRED].includes(state) ||
    hidden

  const {
    palette: {
      common: { darkBlue },
      action: { disabled },
    },
  } = useTheme()

  return (
    <TableCell sx={{ pr: "0px!important" }}>
      <Stack direction="row" flexWrap={"wrap-reverse"} gap={1}>
        <TypeChip
          label={label}
          fontColor={isDisabled ? disabled : color}
          sx={{ width: 110 }}
        />
        {year && (
          <TypeChip
            label={year}
            fontColor={isDisabled ? disabled : darkBlue}
            variant="outlined"
            borderColor={disabled}
          />
        )}
      </Stack>
    </TableCell>
  )
}
